(function() {
  'use strict';
  angular.module('common')
    .filter('procedureCodes', ['$filter', function($filter) {
      return function(procedures) {
        if(!procedures) {
          return "";
        } else {
          var procedureCodes = [];
          for (var index = 0; index < procedures.codes.length; ++index) {
            procedureCodes[index] = $filter('procedureCode')(procedures.codes[index]);
          }
          return procedureCodes.join().replace(/,/g, ', ');
        }
      };
    }]).filter('procedureCode', function() {
      var allButDigits = /\D+/g;
      return function(val) {
        if (!val) {
          return '';
        }
        val = isNaN(val) ? val.replace(allButDigits,'') : val;
        return ('D' + _.padStart(val,4,0).substring(0,4));
      };
    });
})();
